// extracted by mini-css-extract-plugin
export var brand = "_7e-9";
export var compact = "_7e-6";
export var extraSmall = "_7e-7";
export var icon = "_7e-0";
export var large = "_7e-4";
export var light = "_7e-1";
export var medium = "_7e-5";
export var outline = "_7e-b";
export var primaryDark = "_7e-a";
export var primaryLight = "_7e-8";
export var primaryModern = "_7e-c";
export var success = "_7e-2";
export var successSolid = "_7e-3";